export default "/_next/static/images/ai-room-designer-card-3336513f84649de8fc69483b055cca02.png";